module.exports = __webpack_public_path__ + "static/media/honeydew melon.024d752b.jpg";